var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
let ElementNotifications = class ElementNotifications extends LitElement {
    constructor() {
        super(...arguments);
        this.notification = null;
    }
    sendNotification(notification, duration = 5000) {
        this.notification = notification;
        this._timeout = setTimeout(() => {
            this._resetNotification();
        }, duration);
    }
    onClick() {
        this._resetNotification();
    }
    _resetNotification() {
        clearTimeout(this._timeout);
        this.notification = null;
    }
    render() {
        const n = this.notification;
        return html ` <div
      id="alerts-body"
      @click="${() => this.onClick()}"
      class="${classMap({
            'cursor-pointer': n?.message,
            hidden: !n?.message && !n?.html,
            'notification-success': n?.type === 'success',
            'notification-error': n?.type === 'error',
            'notification-information': n?.type === 'information',
        })}
      rounded-[8px] px-[16px] py-[12px] text-body-zero
      shadow-snackbar md:text-md-body
      lg:text-lg-body"
      role="alert"
    >
      ${n?.html ? n?.html : html `<span>${n?.message}</span>`}
    </div>`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], ElementNotifications.prototype, "notification", void 0);
ElementNotifications = __decorate([
    customElement('element-notifications')
], ElementNotifications);
export default ElementNotifications;
//# sourceMappingURL=element-notifications.js.map